/*
 * Copyright 2025 Intuition Robotics ltd
 */
export const config = {
	messagingUrl: "https://us-central1-ir-q-messaging.cloudfunctions.net/api",
	env: "prod"
};
